import { useEffect } from 'react';
import { Map as MapboxMap } from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';

const useMapboxDrawEvents = (map: MapboxMap, draw: MapboxDraw, eventType: string, listener: (ev: any) => void) => {
	useEffect(() => {
		if (!draw) {
			return;
		}

		map.on(eventType, listener);

		return () => {
			map.off(eventType, listener);
		};
	}, [map, draw, eventType, listener]);
};

export default useMapboxDrawEvents;
